import Router from '@eui-util/vue-router';
import routes from './routes';
import Vue from 'vue';
import { ROUTE_BASE } from '@/utils/constants';

/**
 * Setup the router for the core application and export it so it can be used
 * outside of the Vue context.
 */
export default Router(Vue, { base: `${ROUTE_BASE}/`, routes });
